export function isEuCitizen(country: string) {
    const euCountries = ["DE", "AT", "BE", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE"]

    return euCountries.includes(country);
}